import React from "react";
import { Link } from "react-router-dom";
import Logo from "../Logo";
import "./Pages.css";

function Home() {
  return (
    <div className="page-home">
      <section className="hero">
        <div className="hero-logo">
          <Logo />
        </div>
        <h1>Out of County Mileage Calculator for Professional Drivers</h1>
        <p className="hero-tagline">
          Keep an accurate log of out-of-county trips, total miles, and reimbursements. Built for private ambulance services, truck drivers, and independent contractors. Free to use.
        </p>
        <Link to="/calculator" className="cta-button">
          Use the Calculator
        </Link>
      </section>

      <article className="page-content">
        <h2>Why CountyLee?</h2>
        <p>
          CountyLee is a mileage tracking tool designed for professional drivers who need to separate <strong>total mileage</strong> from <strong>out-of-county mileage</strong> for reimbursement, accounting, or tax record-keeping. Unlike generic mileage calculators, CountyLee uses your start and end addresses to identify which counties you left and entered, then calculates exactly how many miles you drove outside your starting county.
        </p>
        <p>
          If you work in private ambulance services, transport, or trucking and your employer or contract pays or reimburses only out-of-county miles, this tool helps you get the numbers right. Enter your trip start and end addresses, and CountyLee shows you total mileage, starting county, ending county, and—most importantly—how many of those miles were out of county.
        </p>
        <h2>Who It&apos;s For</h2>
        <ul>
          <li><strong>Private ambulance and EMS personnel</strong> — Track out-of-county transport miles for accurate reimbursement.</li>
          <li><strong>Truck drivers and independent contractors</strong> — Document miles outside your home county for pay or expense reports.</li>
          <li><strong>Anyone who needs a clear record</strong> — Use the results for payroll, accounting, or your own records. This calculation is for record-keeping purposes only; always confirm rates with your employer or accountant.</li>
        </ul>
        <h2>What Users Say</h2>
        <p>
          &quot;Finally a simple way to get out-of-county miles for our transport runs. Saves time at the end of the week.&quot; — <em>Private ambulance driver</em>
        </p>
        <h2>Get Started</h2>
        <p>
          Go to the <Link to="/calculator">Calculator</Link> page, enter your start and end addresses (or use the location button for your current position), and click &quot;Calculate Out of County Miles.&quot; You&apos;ll see total mileage, out-of-county miles, and the counties you started and ended in. For more details, see our <Link to="/faq">FAQ</Link> and <Link to="/about">About</Link> pages.
        </p>
        <p>
          <Link to="/calculator" className="cta-inline">Use the Calculator &rarr;</Link>
        </p>
      </article>
    </div>
  );
}

export default Home;
